"use client";

import { LinkItem } from "./LinkItem";

export interface LinkItemData {
  href: string;
  icon: React.ReactNode;
  label: string;
  disabled?: boolean;
  desktopOnly?: boolean;
  onClick?: () => void;
}

interface LinksProps {
  links: LinkItemData[];
  className?: string;
  role?: "USER" | "ADMIN" | "GUEST";
}

export const Links = ({ links, className }: LinksProps) => {
  return (
    <div className={`flex flex-col w-full ${className || ""}`}>
      {links.map((link, index) => (
        <LinkItem
          key={`${link.href}-${index}`}
          href={link.href}
          icon={link.icon}
          label={link.label}
          disabled={link.disabled}
          desktopOnly={link.desktopOnly}
          onClick={link.onClick}
        />
      ))}
    </div>
  );
};
